import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, role }) => {
  const accountType = localStorage.getItem("account_type");
  if (!accountType) {
    return <Navigate to="/login" replace />;
  }
 
  // Role check
  if (role && accountType !== role) {
    return <Navigate to={accountType === "admin" ? "/admin/dashboard" : "/dashboard"} replace />;
  }

  return children;
};
export default ProtectedRoute; 